import { render, staticRenderFns } from "./generic-menu-header.vue?vue&type=template&id=3fcbd398&"
import script from "./generic-menu-header.vue?vue&type=script&lang=js&"
export * from "./generic-menu-header.vue?vue&type=script&lang=js&"
import style0 from "./generic-menu-header.vue?vue&type=style&index=0&id=3fcbd398&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports